export default {
  productGrade: {
    id: 'product_grade',
    defaultMessage: 'Esthetic condition:',
  },
  productGradeWithNewBattery: {
    id: 'product_grade_with_new_battery',
    defaultMessage: '{grade} with new battery',
  },
  battery_new: {
    id: 'product_page_no_grade_labels_battery_new',
    defaultMessage: 'New battery',
  },
}
